<wuc-table [isFullWidth]="true" *ngIf="expand">
    <wuc-table-row>
        <wuc-table-cell fontWeight="bold">Dekking & Premie</wuc-table-cell>
    </wuc-table-row>
    <ng-container *ngFor="let coverage of coverages">
        <wuc-table-row>
            <wuc-table-cell>
                {{ coverage.coverageDescription }}
                <div *ngIf="coverage.collectivityDiscount">
                    {{ purchasedProduct.coverage.collectivityDescription }}
                </div>
            </wuc-table-cell>
            <wuc-table-cell position="right">
                <ng-container *ngIf="coverage.premium">
                    <span *ngIf="coverage.premium?.premiumIncludingPremiumTax" class="no-brake">
                        {{ coverage.premium.premiumIncludingPremiumTax | number : "1.2-2" }}
                    </span>
                    <span *ngIf="!coverage.premium.premiumIncludingPremiumTax">gratis</span>
                </ng-container>
                <div *ngIf="coverage.collectivityDiscount" class="no-brake">
                    -{{ coverage.collectivityDiscount.premiumIncludingPremiumTax | number : "1.2-2" }}
                </div>
            </wuc-table-cell>
        </wuc-table-row>
    </ng-container>
    <wuc-table-row border="bottom" *ngIf="coverages.length">
    </wuc-table-row>
    <wuc-table-row *ngIf="totals?.collectivityDiscount > 0 || totals?.offerDiscount > 0">
        <wuc-table-cell>Subtotaal</wuc-table-cell>
        <wuc-table-cell position="right">
            <span class="no-brake">{{ totals.subTotal | number : "1.2-2" }}</span>
        </wuc-table-cell>
    </wuc-table-row>
    <wuc-table-row *ngIf="totals?.collectivityDiscount > 0">
        <wuc-table-cell>Korting</wuc-table-cell>
        <wuc-table-cell position="right">
            <span class="no-brake">{{ -totals.collectivityDiscount | number : "1.2-2" }}</span>
        </wuc-table-cell>
    </wuc-table-row>
    <wuc-table-row *ngIf="purchasedProduct.coverage.offer">
        <wuc-table-cell>{{ purchasedProduct.coverage.offer }}</wuc-table-cell>
        <wuc-table-cell position="right">
            <span class="no-brake">{{ -totals.offerDiscount | number : "1.2-2" }}</span>
        </wuc-table-cell>
    </wuc-table-row>
</wuc-table>
<wuc-table *ngIf="totals" [isFullWidth]="true">
    <wuc-table-row>
        <wuc-table-cell fontWeight="bold">Mijn maandbedrag</wuc-table-cell>
        <wuc-table-cell fontWeight="bold" position="right">
            <span class="no-brake">{{ totals.total | number : "1.2-2" }}</span>
        </wuc-table-cell>
    </wuc-table-row>
</wuc-table>
